export const RECEIVE_ROLE_DONATION_STATS = "RECEIVE_ROLE_DONATION_STATS"
export const GET_ROLE_DONATION_STATS = "GET_ROLE_DONATION_STATS"

export const receiveRoleDonationStats = (stats) => ({
  type: RECEIVE_ROLE_DONATION_STATS,
  stats,
})

export const getRoleDonationStats = (success, error) => ({
  type: GET_ROLE_DONATION_STATS,
  success,
  error,
})
